<template>
  <div class="mt-4 mr-4 ml-4">
    <v-row justify="center">
      <v-col cols="12" sm="6">
        <v-card elevation="3" :color="config.background_light" :dark="config.dark_background">
        <v-toolbar
          v-bind:color="config.primary"
          dark
          flat
        >
          <v-toolbar-title>
            <v-icon>mdi-account-arrow-right</v-icon> Your Chips
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
          class="mr-1"
          icon
          large
          @click="navigateTo({name: 'browse'})"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </v-toolbar>
          <v-container>
            <v-row>
              <v-card :color="config.background_light" flat v-if="createdChipList.length == 0">
                <v-card-title>It doesn't seem you have made any chips yet! Get started by clicking "Create"</v-card-title>
              </v-card>
              <v-card
                :dark="config.dark_background"
                :color="config.background"
                v-bind:key="index"
                v-for="(item, index) in createdChipList"
                class="elevation-4 mr-4 ml-4 mt-2 mb-2 hover-card"
                max-width="180"
                @click="moreInfo(item)"
              >
                <v-img
                  contain
                  style="border-radius: 50%;"
                  lazy-src=""
                  :src="item.image"
                  crossorigin="anonymous"
                  height="auto"
                >
                </v-img>
                <v-list-item three-line>
                  <v-list-item-content>
                    <v-list-item-title class="title mb-1">
                      <v-tooltip open-delay="500" v-if="!item.private" top :color="config.special_1">
                        <template v-slot:activator="{ on }"> <!-- Activate toolbar if you hover over it -->
                          <v-icon class="mb-1" left :color="config.special_1" v-on="on" >mdi-account</v-icon>
                        </template>
                        <h3> This chip was created by you</h3>
                      </v-tooltip>
                      <v-tooltip open-delay="500" v-if="item.private" top v-bind:color="config.special_1">
                        <template v-slot:activator="{ on }"> <!-- Activate toolbar if you hover over it -->
                          <v-icon class="mb-1" left v-bind:color="config.special_1" v-on="on" >mdi-lock-check</v-icon>
                        </template>
                        <h3> Only you can view and edit this chip</h3>
                      </v-tooltip>
                      {{item.name}}
                    </v-list-item-title>
                    <v-list-item-subtitle>{{item.description}}</v-list-item-subtitle>
                  </v-list-item-content>

                </v-list-item>
                <v-spacer></v-spacer>
                <v-card-actions>
                  <v-btn
                    icon
                    large
                    class="ml-1"
                    v-if="loggedIn"
                    @click="editChip(item)"
                    v-on:click.stop
                  >
                    <v-icon v-bind:color="config.primary">mdi-circle-edit-outline</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    large
                    class="ml-1"
                    v-if="loggedIn"
                    @click="printChip(item)"
                    v-on:click.stop
                  >
                    <v-icon v-bind:color="config.primary">mdi-printer</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6">
        <v-card :color="config.background_light" :dark="config.dark_background">
          <v-toolbar flat :color="config.primary" :dark="config.dark_primary">
            <v-toolbar-title>
              Navigation
            </v-toolbar-title>
          </v-toolbar>
          <v-card-title>
            <v-row justify="center">
              <v-btn @click="navigateTo({name: 'home'})" class="mr-2 ml-2" large :color="config.primary" :dark="config.dark_primary">
                Home
              </v-btn>
              <v-btn @click="navigateTo({name: 'library'})" class="mr-2 ml-2" large :color="config.primary" :dark="config.dark_primary">
                Library
              </v-btn>
              <v-btn @click="navigateTo({name: 'browse'})" class="mr-2 ml-2" large :color="config.primary" :dark="config.dark_primary">
                Browse
              </v-btn>
              <v-btn @click="navigateTo({name: 'settings'})" class="mr-2 ml-2" large :color="config.primary" :dark="config.dark_primary">
                Settings
              </v-btn>
            </v-row>
          </v-card-title>
        </v-card>
        <v-card class="mt-4" :color="config.background_light" :dark="config.dark_background">
          <v-toolbar flat :color="config.primary" :dark="config.dark_primary">
            <v-toolbar-title>
              Create a new chip
            </v-toolbar-title>
          </v-toolbar>
          <v-card-title>
            <v-row justify="center" class="mt-4">
              <v-card :color="config.background">
                <v-row justify="center">
                  <div class="mt-2">
                    <v-img crossorigin="anonymous" style="border-radius: 50%;" contain height="100px" width="100px" :src="templateImage"/>
                  </div>
                </v-row>
                <v-card-actions>
                  <v-btn elevation="0" @click="activateTemplateDialog()" large :color="config.primary" :dark="config.dark_primary">
                    Select Template
                  </v-btn>
                  <v-btn elevation="0" @click="editChip(templateSelected)" large :color="config.confirm" :dark="config.dark_primary">
                    Create
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-row>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition"  :key="0"> <!-- Print Page -->
      <f-s-modal :canvas_data="chipInfo.image">
        <template v-slot:actions>
          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Print and Adjust</v-toolbar-title>
        </template>
      </f-s-modal>
    </v-dialog>
    <v-dialog
      v-model="info"
      width="450"
    >
      <modal>
        <template v-slot:title>
          {{ chipInfo.name }}
          <v-tooltip v-if="chipInfo.private" top v-bind:color="config.secondary">
            <template v-slot:activator="{ on }"> <!-- Activate toolbar if you hover over it -->
              <v-icon class="ml-3" v-bind:color="config.secondary" v-on="on" >mdi-lock-check</v-icon>
            </template>
            <h3> Only you can view and edit this chip</h3>
          </v-tooltip>
          <v-tooltip top v-bind:color="config.cancel">
            <template v-slot:activator="{ on }"> <!-- Activate toolbar if you hover over it -->
              <v-btn
                icon
                large
                class="ml-1"
                @click="deleteItem(chipInfo)"
                v-on="on"
                >
                  <v-icon v-bind:color="config.cancel">mdi-delete-forever</v-icon>
              </v-btn>
            </template>
            <h3>Delete this chip forever?</h3>
          </v-tooltip>
        </template>
        <template v-slot:text>
        <v-row
        no-gutters
        >
          <v-col
          cols="8"
          >
            <div>
              {{ chipInfo.description }}
            </div>
            <br>
          </v-col>
          <v-col
          class=""
          cols="4"
          >
          </v-col>
        </v-row>
        <v-divider></v-divider>
        </template>
        <template v-slot:actions> 
          <v-flex class="d-flex mb-3">
            <v-btn
              :color="config.primary"
              :dark="config.dark_primary"
              class="ml-auto mr-auto"
              large
              @click="info = !info; printChip(chipInfo)"
            >
              <span>Print</span>
              <v-icon right>mdi-printer</v-icon>
            </v-btn>
            <v-btn
              :color="config.primary"
              :dark="config.dark_primary"
              class="mr-auto ml-auto"
              large
              @click="info = !info; editChip(chipInfo)"
            >
              <span>Edit this chip</span>
              <v-icon right>mdi-circle-edit-outline</v-icon>
            </v-btn>
          </v-flex>
        </template>
      </modal>
    </v-dialog>
    <v-dialog v-model="templateDialog" max-width="800px"> <!-- Template Dialog -->
      <modal>
        <template v-slot:toolbar>
          <v-toolbar 
          v-bind:color="config.primary"
          dark
          flat
          >
            <h2>
              Click a template to use it
            </h2>
            <v-btn
              class="ml-auto mr-1"
              icon
              large
              @click="templateDialog = false"
            >
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:title>
          <div>
          </div>
        </template>
        <template v-slot:text>
          <v-row justify="center">
            <v-card
              tile
              v-bind:key="index"
              v-for="(item, index) in templateList"
              elevation="0"
              max-width="200"
              max-height="200"
              @click="useTemplate(item)"
              style="border-radius: 50%;"
            >
              <v-img
                contain
                lazy-src=""
                :src="item.image"
                crossorigin="anonymous"
                width="200"
                height="200"
                class="grey--text align-end"
                style="border-radius: 50%;"
              >
              </v-img>
            </v-card>
          </v-row>
          <v-card flat v-if="templateList.length == 0">
            <v-card-title>Sorry, we could not find anything. Try again later.</v-card-title>
          </v-card>
        </template>
        <template v-slot:actions>
          <div>
          </div>
        </template>
      </modal>
    </v-dialog>
  </div>
</template>

<script>
import ItemService from '@/services/ItemService'
import LibraryService from '@/services/LibraryService'
import config from '@/config/config'
import { mapGetters } from 'vuex'
import FSModal from '@/components/FSModal.vue'
import Modal from '@/components/Modal.vue'

export default {
  name: 'dashboard',
  data () {
    return {
      config,
      chipList: [],
      createdChipList: [],
      loading: false,
      userLibrary: [],
      dialog: false,
      chipInfo: {},
      info: false,
      templateList: [],
      templateImage: `${config.backendURL}/public/circle_highres.png`,
      templateSelected: null,
      templateDialog: false
    }
  },
  methods: {
    async useTemplate(item) {
      this.templateSelected = item
      this.templateImage = item.image
      this.templateDialog = false
    },
    async getTemplateList() {
      try {
        const response = await ItemService.getTemplates()
        const array = this.addImages(response.data)
        this.templateList = array
        return array
      } catch (error) {
        return error
      }
    },
    async activateTemplateDialog() {
      this.templateDialog = true
    },
    navigateTo (route) {
      this.$router.push(route)
    },
    async addToLibrary (itemId) {
        try {
          if (this.loggedIn) {
            const response = await LibraryService.add({
              token: this.getUser.token,
              itemId
            });
            if (!response.data.error) {
              this.userLibrary = response.data
            } else {
              this.userLibrary = [{ name: response.data.error }]
            }
          } else {
            this.dialog = true
          }
        } catch (error) {
          throw error
        }
    },
    async removeFromLibrary (itemId) {
      try {
        const response = await LibraryService.remove({
          token: this.getUser.token,
          itemId
        });
        if (!response.error) {
          this.userLibrary = response.data
        } else {
          this.userLibrary = [{ name: response.error }]
        }
      } catch (error) {
        throw error
      }
    },
    itemInLibrary (itemId) {
      if (this.loggedIn) {
        let found = false
        this.userLibrary.forEach(item => {
          if (item._id == itemId) {
            found = true
          }
        });
        return found
      }
    },
    async getUserLibrary () {
      try {
        if (this.loggedIn) {
          const response = await LibraryService.get({
            token: this.getUser.token
          })
          if (!response.data.error) {
            this.userLibrary = response.data
          } else {
            return response.data.error
          }
        }
      } catch (err) {
        throw err
      }
    },
    async deleteItem(item) {
      try {
        const sendObj = {
          itemId: item._id,
          token: this.getUser.token
        }
        const response = await ItemService.delete(sendObj)
        this.info = false
        this.createdChipList = this.createdChipList.filter((createdItem) => createdItem._id != response.data._id)
      } catch(error) {
        this.$router.push({name: 'home'})
        location.reload()
        alert(error)
      }
    },
    moreInfo (item) {
      try {
        this.chipInfo = item
        this.info = true
      } catch (error) {
        throw error
      }
    },
    async printChip (item) {
      this.chipInfo = item
      this.loading = true
      this.dialog = true
      this.loading = false
    },
    async startUp () {
      this.getUserChipsList()
      this.getTemplateList()
    },
    editChip (item) {
      this.$router.push({
          name: 'create',
          params: {
              itemInfo: item
          }
      })
    },
    addImages (array) {
      return array.map(function (item) {
        item.image = config.backendURL + '/public/icons/' + item._id + '.png'
        return item
      })
    },
    async getUserChipsList () {
      try {
        this.loading = true
        const response = await ItemService.getUserCreated({token: this.getUser.token})
        const array = await this.addImages(response.data.items)
        this.loading = false
        this.createdChipList = array
      } catch (error) {
        this.$router.push({name: 'home'})
        location.reload()
        alert(error)
        this.createdChipList = []
      }
    },
  },
  components: {
    FSModal,
    Modal
  },
  mounted () {
    this.startUp()
  },
  computed: {
    ...mapGetters({
      loggedIn: 'loggedIn',
      getSearchInfo: 'getSearchInfo',
      getUser: 'getUser'
    })
  }
}
</script>

<style scoped>
  .container-flex {
    display: flex;
  }
</style>